import { Icon } from '@iconify/react';
import RevealWrap from './RevealWrap';

const REVIEWS = [
  { text: '점심 피크 타임에 주문받느라 정신없었는데, 도입하고 나서 직원 한 명이 빠져도 운영이 될 정도로 여유가 생겼습니다. 어르신 손님들도 생각보다 금방 적응하시더라고요.', name: '김 대표', role: '한식당 운영', initial: '김', color: 'bg-brand-100 text-brand-600' },
  { text: '외국인 손님이 많은 동네인데, 다국어 메뉴가 자동으로 나오니까 영어 메뉴판 따로 만들 필요가 없어졌어요. 진짜 편합니다.', name: '박 대표', role: '음식점 운영', initial: '박', color: 'bg-blue-100 text-blue-600' },
  { text: '다른 테이블오더 쓰다가 와우오더로 바꿨는데, UI가 확실히 깔끔하고 손님들이 주문을 훨씬 잘 하세요. 네이버 리뷰도 알아서 쌓여서 대만족입니다.', name: '이 사장님', role: '카페 운영', initial: '이', color: 'bg-emerald-100 text-emerald-600' },
  { text: '카페 운영하면서 제일 힘든 게 주문 몰릴 때 실수하는 거였는데, QR오더 도입 후 주문 누락이 완전히 사라졌어요.', name: '최 대표', role: '카페 운영', initial: '최', color: 'bg-violet-100 text-violet-600' },
  { text: '치킨 1~2마리 가격에 이게 된다고? 솔직히 반신반의했는데 진짜 가성비가 말이 안 됩니다. 직원 한 명 줄인 효과가 확실히 납니다.', name: '장 사장님', role: '치킨집 운영', initial: '장', color: 'bg-amber-100 text-amber-600' },
  { text: '고객센터 응대가 정말 빠릅니다. 새벽에도 바로 답변이 와서 놀랐어요. 이런 부분에서 진짜 신뢰가 쌓이더라고요.', name: '윤 대표', role: '음식점 운영', initial: '윤', color: 'bg-rose-100 text-rose-600' },
];

export default function Reviews() {
  return (
    <section id="reviews" className="py-28 lg:py-40 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <RevealWrap className="max-w-2xl mb-20">
          <p className="text-brand-600 font-semibold text-sm tracking-wide uppercase mb-3">Reviews</p>
          <h2 className="text-3xl lg:text-5xl font-bold leading-tight tracking-tight text-neutral-900 mb-4">
            사장님들의 실제 후기
          </h2>
          <p className="text-neutral-500 text-lg leading-relaxed mb-6">
            와우오더를 먼저 도입한 사장님들이 직접 전하는 이야기입니다.
          </p>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, j) => (
                <Icon key={j} icon="solar:star-bold" className="text-amber-400 text-lg" />
              ))}
            </div>
            <span className="text-neutral-900 font-bold">4.9</span>
            <span className="text-neutral-400 text-sm">/ 5.0 만족도</span>
          </div>
        </RevealWrap>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 space-y-5">
          {REVIEWS.map((r, i) => (
            <RevealWrap key={r.name} animation="scale" className={`reveal-delay-${(i % 3) + 1}`}>
              <div className="group break-inside-avoid bg-neutral-50/80 border border-neutral-200/80 rounded-3xl p-7 bento-item relative overflow-hidden">
                <div className="absolute -top-20 -right-20 w-40 h-40 bg-brand-400/5 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                <div className="relative z-10">
                  <div className="flex items-center gap-1 mb-4">
                    {[...Array(5)].map((_, j) => (
                      <Icon key={j} icon="solar:star-bold" className="text-amber-400" />
                    ))}
                  </div>
                  <p className="text-neutral-700 leading-relaxed mb-5">&ldquo;{r.text}&rdquo;</p>
                  <div className="flex items-center gap-3 pt-4 border-t border-neutral-200/60">
                    <div className={`w-10 h-10 rounded-full ${r.color} flex items-center justify-center group-hover:scale-110 transition-transform duration-500`}>
                      <span className="font-bold text-sm">{r.initial}</span>
                    </div>
                    <div>
                      <p className="font-semibold text-sm text-neutral-900">{r.name}</p>
                      <p className="text-neutral-500 text-xs">{r.role}</p>
                    </div>
                  </div>
                </div>
              </div>
            </RevealWrap>
          ))}
        </div>
      </div>
    </section>
  );
}
